/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EarlyWarningTableWidgetDataWarningsInner
 */
export interface EarlyWarningTableWidgetDataWarningsInner {
    /**
     * 
     * @type {string}
     * @memberof EarlyWarningTableWidgetDataWarningsInner
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof EarlyWarningTableWidgetDataWarningsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EarlyWarningTableWidgetDataWarningsInner
     */
    'phenomenon': EarlyWarningTableWidgetDataWarningsInnerPhenomenonEnum;
    /**
     * 
     * @type {string}
     * @memberof EarlyWarningTableWidgetDataWarningsInner
     */
    'onset': string;
    /**
     * 
     * @type {string}
     * @memberof EarlyWarningTableWidgetDataWarningsInner
     */
    'expires': string;
    /**
     * 
     * @type {string}
     * @memberof EarlyWarningTableWidgetDataWarningsInner
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof EarlyWarningTableWidgetDataWarningsInner
     */
    'probability_percentage': number;
    /**
     * 
     * @type {string}
     * @memberof EarlyWarningTableWidgetDataWarningsInner
     */
    'level': EarlyWarningTableWidgetDataWarningsInnerLevelEnum;
    /**
     * 
     * @type {object}
     * @memberof EarlyWarningTableWidgetDataWarningsInner
     */
    'area': object;
}

export const EarlyWarningTableWidgetDataWarningsInnerPhenomenonEnum = {
    Avalanches: 'avalanches',
    CoastalEvent: 'coastal-event',
    Flooding: 'flooding',
    Fog: 'fog',
    ForestFire: 'forest-fire',
    HighTemperature: 'high-temperature',
    LowTemperature: 'low-temperature',
    Rain: 'rain',
    RainFlood: 'rain-flood',
    SnowIce: 'snow-ice',
    Thunderstorm: 'thunderstorm',
    Wind: 'wind'
} as const;

export type EarlyWarningTableWidgetDataWarningsInnerPhenomenonEnum = typeof EarlyWarningTableWidgetDataWarningsInnerPhenomenonEnum[keyof typeof EarlyWarningTableWidgetDataWarningsInnerPhenomenonEnum];
export const EarlyWarningTableWidgetDataWarningsInnerLevelEnum = {
    Yellow: 'yellow',
    Orange: 'orange',
    Red: 'red'
} as const;

export type EarlyWarningTableWidgetDataWarningsInnerLevelEnum = typeof EarlyWarningTableWidgetDataWarningsInnerLevelEnum[keyof typeof EarlyWarningTableWidgetDataWarningsInnerLevelEnum];


